import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { usePerformanceAuditMatrix } from "../../Hooks/Features/TalentMatrix/usePerformanceAuditMatrix"
import { useTheme } from "../../context/ThemeContext";
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { SkeletonContainer } from "../Loader/Loader";

const PerformanceAuditMatrix = ({ options, filterValues, setFilterValues }) => {

    const { theme } = useTheme();
    const { tabs, selectedTab, setSelectedTab, columns, rowData, loader, getAgilePerformanceMatrixData } = usePerformanceAuditMatrix({ options, filterValues, setFilterValues });

    return (
        <div>
            <div className="p-2 d-flex justify-content-between align-items-center border-bottom">
                <div className="d-flex gap-2 align-items-center">
                    <div className="text-primary px-2 py-1 rounded" style={{ backgroundColor: theme === "dark" ? "#3f4853" : "#eff6ff" }}><FontAwesomeIcon icon="fa-solid fa-file-circle-check" /></div>
                    <div>
                        <div className="fw-bold text-uppercase">Performance audit matrix</div>
                        <div className="fw-bold text-uppercase mt-1" style={{ color: "#94a3b8", fontSize: "0.7rem" }}>Detailed estimated vs actual delivery audit</div>
                    </div>
                </div>
                <div className='d-flex align-items-center gap-4'>
                    <div className={`tab-menu ${theme === "dark" ? "dark" : ""}`}>
                        {tabs?.map(item => (
                            <div key={item?.key} className={`tab-menu-item ${item?.key === selectedTab ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => { if (selectedTab !== item?.key) { setSelectedTab(item?.key); getAgilePerformanceMatrixData(item?.key === "complexity"); } }}>
                                {item?.label}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="w100" style={{ maxHeight: "40vh", minHeight: "30vh", overflow: "auto" }}>
                {loader ?
                    <div style={{ height: "30vh" }}><SkeletonContainer /></div> :
                    <CommonGrid columns={columns} data={rowData?.length > 0 ? [{ id: "all", title: "", children: rowData }] : []} headerHeight={40} rowHeight={"auto"} strippedTable={true} />}
            </div>
        </div>
    )
}

export default PerformanceAuditMatrix